var isopen_airiosoft_mobile_naviagtion_wrapper = !1, airiosoft_main_navigation_wrapper_popishidden = !0;

function airiosoft_custom_toggle_menu_mobile() {
    airiosoft_main_navigation_wrapper_popishidden ? (document.getElementById("airiosoft_main_navigation_wrapper_pop").classList.add("active"), airiosoft_main_navigation_wrapper_popishidden = !1) : (document.getElementById("airiosoft_main_navigation_wrapper_pop").classList.remove("active"), airiosoft_main_navigation_wrapper_popishidden = !0)
}

var i, airiosoft_mobile_acc = document.getElementsByClassName("airiosoft_mobile_naviagtion_dropbox_button_container");
for (i = 0; i < airiosoft_mobile_acc.length; i++) airiosoft_mobile_acc[i].addEventListener("click", function () {
    this.classList.toggle("active"), this.nextElementSibling.classList.toggle("active"), isopen_airiosoft_mobile_naviagtion_wrapper = !0;
    var siblings = this.parentNode.parentNode.children;
    for (var i = 0; i < siblings.length; i++) {
        var sibling = siblings[i];
        if(sibling===this.parentNode) {

        } else {
            if (sibling.classList.contains("airiosoft_mobile_naviagtion_dropbox_wrapper")||sibling.classList.contains("airiosoft_mobile_naviagtion_store_selector_container")) {
                var children = sibling.children;
                for (var j = 0; j < children.length; j++) {
                    var child = children[j];
                    if (child.classList.contains("airiosoft_mobile_naviagtion_dropbox_button_container") || child.classList.contains("airiosoft_mobile_naviagtion_dropbox_panel_container")) {
                        // 找到符合条件的子元素
                        child.classList.remove("active");
                    }
                }
            }
        }

    }
});
let interObsever = new IntersectionObserver(observerCallback),
    nodes = document.getElementsByClassName("airiosoft_mobile_naviagtion_store_selector_container");

function observerCallback(i) {
    i.forEach(function (i) {
        if (!i.isIntersecting) for (let e = 0; e < i.target.children.length; e++) i.target.children[e].classList.remove("active")
    })
}

function initObserve() {
    for (let i = 0; i < nodes.length; i++) interObsever.observe(nodes[i])
}

function airiosoft_main_navigation_wrapper_pop_scroll_function(i) {
    if (isopen_airiosoft_mobile_naviagtion_wrapper) {
        for (var e = document.getElementsByClassName("airiosoft_mobile_naviagtion_store_selector_container"), o = 0; o < e.length; o++) for (var n = e[o].getElementsByClassName("airiosoft_mobile_naviagtion_dropbox_panel_container"), t = 0; t < n.length; t++) n[t].classList.remove("active");
        isopen_airiosoft_mobile_naviagtion_wrapper = !1
    }
}

initObserve(), window.addEventListener("beforeunload", function (i) {
    for (let i = 0; i < nodes.length; i++) interObsever.unobserve(nodes[i]);
    interObsever.disconnect(), interObsever = null, nodes = null
});
